import React from 'react';
import { isDingTalkPcUA, getDingtalkUrl } from '@libs/shared';
import { corpUserStore } from '~/models';

if (isDingTalkPcUA()) {
    const originalOpen = window.open;
    window.open = new Proxy(originalOpen, {
        apply(target, ctx, args) {
            const [url, openTarget, ...otherArgs] = args;
            if (
                corpUserStore.isDingTalkCorp &&
                (!openTarget || !['_self', '_top', '_parent'].includes(openTarget))
            ) {
                return target.apply(ctx, [getDingtalkUrl(url), openTarget, ...otherArgs]);
            }
            return target.apply(ctx, args);
        }
    });

    const originalCreateElement = React.createElement;
    React.createElement = new Proxy(originalCreateElement, {
        apply(target, ctx, args) {
            const [type, originalProps, ...otherArgs] = args;
            if (
                type === 'a' &&
                corpUserStore.isDingTalkCorp &&
                originalProps?.href &&
                originalProps.target &&
                !['_self', '_top', '_parent'].includes(originalProps.target)
            ) {
                return target.apply(ctx, [
                    type,
                    {
                        ...originalProps,
                        href: getDingtalkUrl(originalProps.href)
                    },
                    ...otherArgs
                ]);
            }
            return target.apply(ctx, args);
        }
    });
}
